// Hiring v3 / Ticket G4 — Outstanding-documents dashboard alert.
// Shows new hires with onboarding paperwork sitting in their inbox
// (status sent / started / completed; not yet signed/verified). Group by
// user; sorted oldest hire first so the longest-overdue surfaces top.
export function OutstandingDocsAlert({ docs }) {
  // Group by user_id.
  const byUser = {};
  for (const d of docs) {
    const k = d.user_id;
    if (!byUser[k]) byUser[k] = { user_name: d.user_name, location_name: d.location_name,
                                    days: Math.max(0, Math.round(d.days_since_hire || 0)),
                                    items: [] };
    byUser[k].items.push(d);
  }
  const groups = Object.values(byUser).sort((a, b) => b.days - a.days);
  return (
    <div style={{ padding: 14, background: '#fef9ee', border: '1px solid #f5e6c8',
                  borderLeft: '4px solid var(--gold)', borderRadius: 8 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#8e6c33',
                    textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>
        Outstanding paperwork · {groups.length} hire{groups.length === 1 ? '' : 's'}
      </div>
      <div style={{ fontSize: 13, color: '#444', marginBottom: 10 }}>
        New hires with onboarding documents not yet completed. Once master
        PDFs are configured (Phase 2), candidates will see download/sign
        actions on their profile.
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {groups.slice(0, 8).map(g => (
          <div key={g.user_name} style={{ background: '#fff', border: '1px solid #f5e6c8',
                                            borderRadius: 6, padding: 8, fontSize: 13 }}>
            <strong>{g.user_name}</strong> at {g.location_name || '—'}
            {' · '}{g.days}d since hire
            {' · '}{g.items.length} doc{g.items.length === 1 ? '' : 's'} pending
            <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
              {g.items.map(d => d.display_name).join(' · ')}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
